function hexToBytes(hex) {
    const bytes = [];
    for (let i = 0; i < hex.length; i += 2) {
        bytes.push(parseInt(hex.substr(i, 2), 16));
    }
    return new Uint8Array(bytes);
}
const secretKey = "mysecretkey12345";
// Web Crypto AES decryption function
async function decryptResponse(encryptedData, ivHex) {
    try {
        // Step 1: Hash the secret key using SHA-256
        const encoder = new TextEncoder();
        const keyMaterial = encoder.encode(secretKey);
        const hashedKey = await crypto.subtle.digest('SHA-256', keyMaterial);

        // Step 2: Convert the IV and encryptedData to Uint8Array
        const iv = hexToBytes(ivHex);
        const encryptedBuffer = hexToBytes(encryptedData);

        // Step 3: Import the hashed key as an AES-CBC key
        const cryptoKey = await crypto.subtle.importKey(
            'raw',
            hashedKey,
            { name: 'AES-CBC' },
            false,
            ['decrypt']
        );
        // Step 4: Decrypt the data
        const decryptedBuffer = await crypto.subtle.decrypt(
            { name: 'AES-CBC', iv },
            cryptoKey,
            encryptedBuffer
        );
        // Step 5: Decode the decrypted buffer to a string
        const decoder = new TextDecoder();
        const decryptedText = decoder.decode(decryptedBuffer);
        const jsonResponse = JSON.parse(decryptedText);
        // Step 6: Parse the decrypted data as JSON
        return jsonResponse
    } catch (error) {
        console.error('Decryption failed:', error);
        throw new Error('Decryption failed or invalid data');
    }
}

export default decryptResponse;
